import store from '@/state/store'

export default [{
    path: '/',
    meta: {
        authRequired: true
    },
    name: 'home',
    component: () => import('./views/home'),
},
{
    path: '/services/edit/:id',
    name: 'EditService',
    component: () => import('./views/services/product/list/editProduct.vue'),
    meta: {
        requiresAuth: true
    }
},
{
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login/login'),
    meta: {
        title: "Login",
        beforeResolve(routeTo, routeFrom, next) {
            // If the user is already logged in
            if (store.getters['auth/loggedIn']) {
                // Redirect to the home page instead
                next({
                    name: 'home'
                })
            } else {
                // Continue to the login page
                next()
            }
        },
    },
},
{
    path: '/register',
    name: 'register',
    component: () => import('./views/account/register'),
    meta: {
        title: "Register",
        beforeResolve(routeTo, routeFrom, next) {
            // If the user is already logged in
            if (store.getters['auth/loggedIn']) {
                // Redirect to the home page instead
                next({
                    name: 'home'
                })
            } else {
                // Continue to the login page
                next()
            }
        },
    },
},
{
    path: '/list-customer',
    name: 'List Customer',
    meta: { title: "List Customer", authRequired: true },
    component: () => import('./views/customer/list-customer.vue'),
},


{
    path: '/sales',
    name: 'Sales',
    meta: { title: "Sales", authRequired: true },
    component: () => import('./views/sales/sales.vue'),
},
{
    path: '/list-category',
    name: 'Category',
    meta: { title: "Category", authRequired: true },
    component: () => import('./views/services/category/list-category.vue'),
},
{
    path: '/list-payment',
    name: 'List Payment Type',
    meta: { title: "List Payment Type", authRequired: true },
    component: () => import('./views/payment/list/list-payment.vue'),
},
{
    path: '/create-payment-type',
    name: 'Payment Type',
    meta: { title: "Payment Type", authRequired: true },
    component: () => import('./views/payment/create/create-payment.vue'),
}, {
    path: '/list-services',
    name: 'List Services',
    meta: { title: "List Services", authRequired: true },
    component: () => import('./views/services/product/list/list-product.vue'),
},
 
{
    path: '/create-services',
    name: 'Create Services',
    meta: { title: "Create Services", authRequired: true },
    component: () => import('./views/services/product/create/create-product.vue'),
},
{
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('./views/account/forgot-password'),
    meta: {
        title: "Forgot password",
        beforeResolve(routeTo, routeFrom, next) {
            // If the user is already logged in
            if (store.getters['auth/loggedIn']) {
                // Redirect to the home page instead
                next({
                    name: 'home'
                })
            } else {
                // Continue to the login page
                next()
            }
        },
    },
},
{
    path: '/logout',
    name: 'logout',
    meta: {
        title: "Logout",
        authRequired: true,
        beforeResolve(routeTo, routeFrom, next) {
            if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
                store.dispatch('auth/logOut')
            } else {
                store.dispatch('authfack/logout')
            }
            const authRequiredOnPreviousRoute = routeFrom.matched.some(
                (route) => route.push('/login')
            )
            // Navigate back to previous page, or home as a fallback
            next(authRequiredOnPreviousRoute ? {
                name: 'default'
            } : {
                ...routeFrom
            })
        },
    },
},


// baru
//master data
//barang
{
    path: '/list-barang',
    name: 'List Barang',
    meta: { title: "List Barang", authRequired: true },
    component: () => import('./views/1master/barang/list/list-barang.vue'),
},
{
    path: '/create-barang',
    name: 'Create Barang',
    meta: { title: "Create Barang", authRequired: true },
    component: () => import('./views/1master/barang/create/create-barang.vue'),
},
//lcd
{
    path: '/list-lcd',
    name: 'List Lcd',
    meta: { title: "List Lcd", authRequired: true },
    component: () => import('./views/1master/lcd/list/list-lcd.vue'),
},
{
    path: '/create-lcd',
    name: 'Create Lcd',
    meta: { title: "Create Lcd", authRequired: true },
    component: () => import('./views/1master/lcd/create/create-lcd.vue'),
},
//nakes
{
    path: '/list-nakes',
    name: 'List Nakes',
    meta: { title: "List Nakes", authRequired: true },
    component: () => import('./views/1master/nakes/list/list-nakes.vue'),
},
{
    path: '/create-nakes',
    name: 'Create Nakes',
    meta: { title: "Create Nakes", authRequired: true },
    component: () => import('./views/1master/nakes/create/create-nakes.vue'),
},
//pasien
{
    path: '/master/list-pasien',
    name: 'List Pasien',
    meta: { title: "List Pasien", authRequired: true },
    component: () => import('./views/Master/Patient/Master/list/list-pasien.vue'),
},
{
    path: '/master/create-pasien',
    name: 'Create Pasien',
    meta: { title: "Create Pasien", authRequired: true },
    component: () => import('./views/Master/Patient/Master/create/create-pasien.vue'),
},
{
    path: '/master/patient/queue',
    name: 'Queue Patient',
    meta: { title: "Queue Patient", authRequired: true },
    component: () => import('./views/Master/Patient/queue/QueueView.vue'),
},
//pegawai
{
    path: '/list-pegawai',
    name: 'List Pegawai',
    meta: { title: "List Pegawai", authRequired: true },
    component: () => import('./views/1master/pegawai/list/list-pegawai.vue'),
},
{
    path: '/create-pegawai',
    name: 'Create Pegawai',
    meta: { title: "Create Pegawai", authRequired: true },
    component: () => import('./views/1master/pegawai/create/create-pegawai.vue'),
},
//Supplier 
{
    path: '/master/supplier',
    name: 'List Supplier',
    meta: { title: "List Supplier", authRequired: true },
    component: () => import('./views/Master/Supplier/list/list-supplier.vue'),
},
{
    path: '/master/supplier/create',
    name: 'Create Supplier',
    meta: { title: "Create Supplier", authRequired: true },
    component: () => import('./views/Master/Supplier/create/create-supplier.vue'),
},
//offices
{
    path: '/master/list-offices',
    name: 'List Offices',
    meta: { title: "List Offices", authRequired: true },
    component: () => import('./views/Master/Office/list/list-offices.vue'),
},
{
    path: '/master/create-offices',
    name: 'Create Offices',
    meta: { title: "Create Offices", authRequired: true },
    component: () => import('./views/Master/Office/create/create-offices.vue'),
},
//Tarif Tindakan
{
    path: '/list-tarif',
    name: 'List Tarif',
    meta: { title: "List Tarif", authRequired: true },
    component: () => import('./views/1master/tarif_tindakan/list/list-tarif.vue'),
},
{
    path: '/create-tarif',
    name: 'Create Tarif',
    meta: { title: "Create Tarif", authRequired: true },
    component: () => import('./views/1master/tarif_tindakan/create/create-tarif.vue'),
},


//Gaji
{
    path: '/list-gaji',
    name: 'List Gaji',
    meta: { title: "List Gaji", authRequired: true },
    component: () => import('./views/1gaji/list/list-gaji.vue'),
},
{
    path: '/create-gaji',
    name: 'Create Gaji',
    meta: { title: "Create Gaji", authRequired: true },
    component: () => import('./views/1gaji/create/create-gaji.vue'),
},

//Hak akses
{
    path: '/list-akses',
    name: 'List Akses',
    meta: { title: "List Akses", authRequired: true },
    component: () => import('./views/1hak_akses/list/list-akses.vue'),
},
{
    path: '/create-akses',
    name: 'Create Akses',
    meta: { title: "Create Akses", authRequired: true },
    component: () => import('./views/1hak_akses/create/create-akses.vue'),
},

//Informasi Harga
{
    path: '/list-informasi-harga',
    name: 'List Informasi Harga',
    meta: { title: "List Informasi Harga", authRequired: true },
    component: () => import('./views/1informasi_harga/list/list-informasi-harga.vue'),
},

//Informasi Pasien
{
    path: '/list-informasi-pasien',
    name: 'List Informasi Pasien',
    meta: { title: "List Informasi Pasien", authRequired: true },
    component: () => import('./views/1informasi_pasien/list/list-informasi-pasien.vue'),
},

//Laporan
//barang keluar
{
    path: '/laporan-barang-keluar',
    name: 'Laporan Barang Keluar',
    meta: { title: "Laporan Barang Keluar", authRequired: true },
    component: () => import('./views/1laporan/barang_keluar/barang_keluar.vue'),
},
//jasa pelayanan
{
    path: '/laporan-jasa-pelayanan',
    name: 'Laporan Jasa Pelayanan',
    meta: { title: "Laporan Jasa Pelayanan", authRequired: true },
    component: () => import('./views/1laporan/jasa_pelayanan/jasa_pelayanan.vue'),
},
//konsinyasi
{
    path: '/laporan-konsinyasi',
    name: 'Laporan Konsinyasi',
    meta: { title: "Laporan Konsinyasi", authRequired: true },
    component: () => import('./views/1laporan/konsinyasi/konsinyasi.vue'),
},
//lhk
{
    path: '/laporan-lhk',
    name: 'Laporan LHK',
    meta: { title: "Laporan LHK", authRequired: true },
    component: () => import('./views/1laporan/lhk/lhk.vue'),
},
//laba rugi apotek
{
    path: '/laporan-laba-rugi-apotek',
    name: 'Laporan Laba Rugi Apotek',
    meta: { title: "Laporan Laba Rugi Apotek", authRequired: true },
    component: () => import('./views/1laporan/laba_rugi_apotek/labaRugiApotek.vue'),
},
//laba rugi klinik
{
    path: '/laporan-laba-rugi-klinik',
    name: 'Laporan Laba Rugi Klinik',
    meta: { title: "Laporan Laba Rugi Klinik", authRequired: true },
    component: () => import('./views/1laporan/laba_rugi_klinik/labaRugiKlinik.vue'),
},
//penerimaan apotek
{
    path: '/laporan-penerimaan-apotek',
    name: 'Laporan Penerimaan Apotek',
    meta: { title: "Laporan Penerimaan Apotek", authRequired: true },
    component: () => import('./views/1laporan/penerimaan/apotek/penerimaanApotek.vue'),
},
//penerimaan klinik
{
    path: '/laporan-penerimaan-klinik',
    name: 'Laporan Penerimaan Klinik',
    meta: { title: "Laporan Penerimaan Klinik", authRequired: true },
    component: () => import('./views/1laporan/penerimaan/klinik/penerimaanKlinik.vue'),
},
//laporan pengadaan
{
    path: '/laporan-pengadaan',
    name: 'Laporan Pengadaan',
    meta: { title: "Laporan Pengadaan", authRequired: true },
    component: () => import('./views/1laporan/pengadaan/laporanPengadaan.vue'),
},
//laporan pengeluaran
{
    path: '/laporan-pengeluaran',
    name: 'Laporan Pengeluaran',
    meta: { title: "Laporan Pengeluaran", authRequired: true },
    component: () => import('./views/1laporan/pengeluaran/laporanPengeluaran.vue'),
},
//laporan pengeluaran gaji
{
    path: '/laporan-pengeluaran-gaji',
    name: 'Laporan Pengeluaran Gaji',
    meta: { title: "Laporan Pengeluaran Gaji", authRequired: true },
    component: () => import('./views/1laporan/pengeluaran_gaji/laporanPengeluaranGaji.vue'),
},
//laporan stok barang
{
    path: '/laporan-stok-barang',
    name: 'Laporan Stok Barang',
    meta: { title: "Laporan Stok Barang", authRequired: true },
    component: () => import('./views/1laporan/stok_barang/laporanStokBarang.vue'),
},

//manajemen stok
//barang masuk
{
    path: '/manajemen-barang-masuk',
    name: 'List Barang Masuk',
    meta: { title: "List Barang Masuk", authRequired: true },
    component: () => import('./views/1manajemen_stok/barang_masuk/list/listBarangMasuk.vue'),
},
{
    path: '/createBarangMasuk',
    name: 'Create Barang Masuk',
    meta: { title: "Create Barang Masuk", authRequired: true },
    component: () => import('./views/1manajemen_stok/barang_masuk/create/createBarangMasuk.vue'),
},
//pengadaan
{
    path: '/manajemen-pengadaan',
    name: 'List Pengadaan',
    meta: { title: "List Pengadaan", authRequired: true },
    component: () => import('./views/1manajemen_stok/pengadaan/list/listPengadaan.vue'),
},
{
    path: '/createPengadaan',
    name: 'Create Pengadaan',
    meta: { title: "Create Pengadaan", authRequired: true },
    component: () => import('./views/1manajemen_stok/pengadaan/create/createPengadaan.vue'),
},
//pengadaan konsinyasi
{
    path: '/manajemen-pengadaan-konsinyasi',
    name: 'List Pengadaan Konsinyasi',
    meta: { title: "List Pengadaan Konsinyasi", authRequired: true },
    component: () => import('./views/1manajemen_stok/pengadaan_konsinyasi/list/listPengadaanKonsinyasi.vue'),
},
{
    path: '/createPengadaanKonsinyasi',
    name: 'Create Pengadaan Konsinyasi',
    meta: { title: "Create Pengadaan Konsinyasi", authRequired: true },
    component: () => import('./views/1manajemen_stok/pengadaan_konsinyasi/create/createPengadaanKonsinyasi.vue'),
},
//inventory
//stocks
{
    path: '/inventory/stock/master',
    name: 'List Stocks',
    meta: { title: "List Stocks", authRequired: true },
    component: () => import('./views/Inventory/Stock/Master/list/listStocks.vue'),
},
{
    path: '/inventory/stock/master/create',
    name: 'Create Stocks',
    meta: { title: "Create Stocks", authRequired: true },
    component: () => import('./views/Inventory/Stock/Master/create/createStocks.vue'),
},
//item category
{
    path: '/inventory-item-category',
    name: 'List Item Category',
    meta: { title: "List Item Category", authRequired: true },
    component: () => import('./views/Inventory/Item/Category/list/list-itemCategory.vue'),
},
{
    path: '/inventory-item-category/create',
    name: 'Create Item Category',
    meta: { title: "Create Item Category", authRequired: true },
    component: () => import('./views/Inventory/Item/Category/create/create-itemCategory.vue'),
},
//items
{
    path: '/inventory/items/list',
    name: 'List Items',
    meta: { title: "List Items", authRequired: true },
    component: () => import('./views/Inventory/Item/Master/list/list-items.vue'),
},
{
    path: '/inventory/items/create',
    name: 'Create Items',
    meta: { title: "Create Items", authRequired: true },
    component: () => import('./views/Inventory/Item/Master/create/create-items.vue'),
},
{
    path: '/inventory/items/consigment',
    name: 'Consigment Items',
    meta: { title: "Consigment Items", authRequired: true },
    component: () => import('./views/Inventory/Item/Master/consignment/consignment.vue'),
},
//item unit
{
    path: '/inventory/unit/item-unit',
    name: 'List Item Unit',
    meta: { title: "List Item Unit", authRequired: true },
    component: () => import('./views/Inventory/Item/Unit/itemUnit/list/list-itemUnit.vue'),
},
{
    path: '/inventory/unit/item-unit/create',
    name: 'Create Item Unit',
    meta: { title: "Create Item Unit", authRequired: true },
    component: () => import('./views/Inventory/Item/Unit/itemUnit/create/create-itemUnit.vue'),
},
//unit
{
    path: '/inventory/master/unit',
    name: 'List Unit',
    meta: { title: "List Unit", authRequired: true },
    component: () => import('./views/Inventory/Item/Unit/Master/list/list-unit.vue'),
},
{
    path: '/inventory/master/unit/create',
    name: 'Create Unit',
    meta: { title: "Create Unit", authRequired: true },
    component: () => import('./views/Inventory/Item/Unit/Master/create/create-unit.vue'),
},
//Supplier Item
{
    path: '/inventory/supplier-item',
    name: 'List Supplier Item',
    meta: { title: "List Item Unit", authRequired: true },
    component: () => import('./views/Inventory/SupplierItem/list/list-supplierItem.vue'),
},
{
    path: '/inventory/supplier-item/create',
    name: 'Create Supplier Item',
    meta: { title: "Create Supplier Item", authRequired: true },
    component: () => import('./views/Inventory/SupplierItem/create/create-supplierItem.vue'),
},
//stock-monthly
{
    path: '/inventory/stock/periodic',
    name: 'List Stock Monthly',
    meta: { title: "List Stock Monthly", authRequired: true },
    component: () => import('./views/Inventory/Stock/Periodic/list/stockMonthly.vue'),
},

//pelayanan
//catatan pasein
{
    path: '/pelayanan-catatan-pasien',
    name: 'Catatan Pasien',
    meta: { title: "Catatan Pasien", authRequired: true },
    component: () => import('./views/1pelayanan/catatan_pasien/catatanPasien.vue'),
},
//diagnosis
{
    path: '/pelayanan-diagnosis',
    name: 'Diagnosis',
    meta: { title: "Diagnosis", authRequired: true },
    component: () => import('./views/1pelayanan/diagnosis/diagnosis.vue'),
},
//kasir
{
    path: '/pelayanan-kasir',
    name: 'Kasir',
    meta: { title: "Kasir", authRequired: true },
    component: () => import('./views/1pelayanan/kasir/kasir.vue'),
},
//pemeriksaan awal
{
    path: '/pelayanan-pemeriksaan-awal',
    name: 'Pemeriksaan Awal',
    meta: { title: "Pemeriksaan Awal", authRequired: true },
    component: () => import('./views/1pelayanan/pemeriksaan_awal/pemeriksaanAwal.vue'),
},
//pendaftaran
{
    path: '/pelayanan-pendaftaran',
    name: 'Pendaftaran',
    meta: { title: "Pendaftaran", authRequired: true },
    component: () => import('./views/1pelayanan/pendaftaran/pendaftaran.vue'),
},
//tindakan
{
    path: '/pelayanan-tindakan',
    name: 'Tindakan',
    meta: { title: "Tindakan", authRequired: true },
    component: () => import('./views/1pelayanan/tindakan/tindakan.vue'),
},

//Pelunasan Pengadaan
{
    path: '/list-pelunasan-pengadaan',
    name: 'List Pelunasan Pengadaan',
    meta: { title: "List Pelunasan Pengadaan", authRequired: true },
    component: () => import('./views/1pelunasan_pengadaan/list/listPelunasanPengadaan.vue'),
},
{
    path: '/create-pelunasan-pengadaan',
    name: 'Create Pelunasan Pengadaan',
    meta: { title: "Create Pelunasan Pengadaan", authRequired: true },
    component: () => import('./views/1pelunasan_pengadaan/create/createPelunasanPengadaan.vue'),
},

//Pengeluaran
{
    path: '/list-pengeluaran',
    name: 'List Pengeluaran',
    meta: { title: "List Pengeluaran", authRequired: true },
    component: () => import('./views/1pengeluaran/list/listPengeluaran.vue'),
},
{
    path: '/create-pengeluaran',
    name: 'Create Pengeluaran',
    meta: { title: "Create Pengeluaran", authRequired: true },
    component: () => import('./views/1pengeluaran/create/createPengeluaran.vue'),
},

//penjualan
//bebas
{
    path: '/penjualan-bebas',
    name: 'Create Penjualan Bebas',
    meta: { title: "Create Penjualan Bebas", authRequired: true },
    component: () => import('./views/1penjualan/bebas/createPenjualanBebas.vue'),
},
//data
{
    path: '/penjualan-data',
    name: 'List Penjualan Data',
    meta: { title: "List Penjualan Data", authRequired: true },
    component: () => import('./views/1penjualan/data/listPenjualanData.vue'),
},
//resep
{
    path: '/penjualan-resep',
    name: 'Create Penjualan Resep',
    meta: { title: "Create Penjualan Resep", authRequired: true },
    component: () => import('./views/1penjualan/resep/createPenjualanResep.vue'),
},

//rekapitulasi Stok
{
    path: '/rekapitulasi-stok',
    name: 'Rekapitulasi Stok',
    meta: { title: "Rekapitulasi Stok", authRequired: true },
    component: () => import('./views/1rekapitulasi_stok/rekapitulasiStok.vue'),
},

//satu sehat
{
    path: '/satu-sehat',
    name: 'Satu Sehat',
    meta: { title: "Satu Sehat", authRequired: true },
    component: () => import('./views/1satu_sehat/satuSehat.vue'),
},

//transaction
//stock in
//list
{
    path: '/inventory/stock-in',
    name: 'List Stock In',
    meta: { title: "List Stock In", authRequired: true },
    component: () => import('./views/Inventory/Stock/Transaction/In/Master/list/list-StockIn.vue'),
},
//create
{
    path: '/inventory/stock-in/create',
    name: 'Create Stock In',
    meta: { title: "Create Stock In", authRequired: true },
    component: () => import('./views/Inventory/Stock/Transaction/In/Master/create/createStockIn.vue'),
},
//stock in detail
// {
//     path: '/transaction/stock-in-detail',
//     name: 'List Stock In Detail',
//     meta: { title: "List Stock In Detail", authRequired: true },
//     component: () => import('./views/transaction/stockInDetail/list/list-StockInDetail.vue'),
// },
//stock out
{
    path: '/inventory/stock-out',
    name: 'List Stock Out',
    meta: { title: "List Stock Out", authRequired: true },
    component: () => import('./views/Inventory/Stock/Transaction/Out/list-StockOut.vue'),
},
//stock out detail
// {
//     path: '/transaction/stock-out-detail',
//     name: 'List Stock Out Detail',
//     meta: { title: "List Stock Out Detail", authRequired: true },
//     component: () => import('./views/transaction/stockOutDetail/list/list-StockOutDetail.vue'),
// },
//stock in payment


//medical

//medical Records
{
    path: '/medical/records/list',
    name: 'List Medical Records',
    meta: { title: "List Medical Records", authRequired: true },
    component: () => import('./views/medical/medicalRecords/list/medicalRecordsList.vue'),
},
{
    path: '/medical/records/create/:patientId?',
    name: 'Create Medical Records',
    meta: { title: "Create Medical Records", authRequired: true },
    component: () => import('./views/medical/medicalRecords/create/createMedicalRecords.vue'),
},
{
    path: '/medical/records/detail/:id?',
    name: 'Detail Medical Records',
    meta: { title: "Detail Medical Records", authRequired: true },
    component: () => import('./views/medical/medicalRecords/detail/detailMedicalRecord.vue'),
},
{
    path: '/work-order/list',
    name: 'List Work Order',
    meta: { title: "List Work Order", authRequired: true },
    component: () => import('./views/medical/workOrder/listWorkOrder.vue'),
},
//recipe
{
    path: '/medical/recipe/list',
    name: 'List Recipe',
    meta: { title: "List Recipe", authRequired: true },
    component: () => import('./views/medical/recipe/list/list-Recipe.vue'),
},
{
    path: '/medical/recipe/create',
    name: 'Create Recipe',
    meta: { title: "Create Recipe", authRequired: true },
    component: () => import('./views/medical/recipe/create/create-Recipe.vue'),
},

//treatment
{
    path: '/medical/treatment-categories/create',
    name: 'Create Treatment Categories',
    meta: { title: "Create Treatment Categories", authRequired: true },
    component: () => import('./views/medical/treatment/category/create/CreateTreatmentCategory.vue'),
},
{
    path: '/medical/treatment-categories/list',
    name: 'List Treatment Categories',
    meta: { title: "List Treatment Categories", authRequired: true },
    component: () => import('./views/medical/treatment/category/list/treatmentCategory.vue'),
},
{
    path: '/medical/treatment/create',
    name: 'Create Treatment ',
    meta: { title: "Create Treatment ", authRequired: true },
    component: () => import('./views/medical/treatment/master/create/CreateTreatment.vue'),
},
{
    path: '/medical/treatment/list',
    name: 'List Treatment ',
    meta: { title: "List Treatment", authRequired: true },
    component: () => import('./views/medical/treatment/master/list/ListTreatment.vue'),
},
// diagnosis
{
    path: '/medical/diagnosis/create',
    name: 'Create diagnosis',
    meta: { title: "Create diagnosis", authRequired: true },
    component: () => import('./views/medical/diagnosis/create/createDiagnosis.vue'),
},
{
    path: '/medical/diagnosis/list',
    name: 'List diagnosis',
    meta: { title: "List diagnosis", authRequired: true },
    component: () => import('./views/medical/diagnosis/list/listDiagnosis.vue'),
},
//salary
{
    path: '/employee/salary/list',
    name: 'List Salary Allowance',
    meta: { title: "List salary Allowance", authRequired: true },
    component: () => import('./views/salary/master/list/listMasterSalary.vue'),
},

{
    path: '/employee/salary/create',
    name: 'Create Salary',
    meta: { title: "Create Salary", authRequired: true },
    component: () => import('./views/salary/master/create/CreateMasterSalary.vue'),
},
{
    path: '/employee/salary/transaction',
    name: 'List Salary transaction',
    meta: { title: "List salary transaction", authRequired: true },
    component: () => import('./views/salary/transaction/trnSalary.vue'),
},

//finance
{
    path: '/cashier',
    name: 'Cashier',
    meta: { title: "Cashier", authRequired: true },
    component: () => import('./views/cashier/cashierMenu.vue'),
},


//invoice
{
    path: '/finance/invoice/list',
    name: 'List Invoice',
    meta: { title: "List Invoice", authRequired: true },
    component: () => import('./views/Finance/Invoices/list/list-Invoice.vue'),
},
// {
//     path: '/finance/invoices/:id', 
//     name: 'Detail Invoice',   
//     meta: { title: "Detail Invoice", authRequired: true },          
//     component: () => import('@/views/transaction/invoice/DetailInvoice.vue'),
// },

//payment method
{
    path: '/finance/payment-method/list',
    name: 'List Payment Method',
    meta: { title: "List Payment Method", authRequired: true },
    component: () => import('./views/Finance/Payment/list/list-PaymentMethod.vue'),
},
{
    path: '/finance/payment-method/create',
    name: 'Create Payment Method',
    meta: { title: "Create Payment Method", authRequired: true },
    component: () => import('./views/Finance/Payment/create/create-PaymentMethod.vue'),
},

//expenses
//expenses category
{
    path: '/finance/expenses/category/list',
    name: 'List Expenses Category',
    meta: { title: "List Expenses Category", authRequired: true },
    component: () => import('./views/Finance/Expenses/Category/list/list-ExpensesCategory.vue'),
},
{
    path: '/finance/expenses/category/create',
    name: 'Create Expenses Category',
    meta: { title: "Create Expenses Category", authRequired: true },
    component: () => import('./views/Finance/Expenses/Category/create/create-ExpensesCategory.vue'),
},
//expenses
{
    path: '/finance/expenses/transaction/expenses-master',
    name: 'List Transaction Expenses',
    meta: { title: "List Transaction Expenses", authRequired: true },
    component: () => import('./views/Finance/Expenses/Transaction/Master/list/list-ExpensesMaster.vue'),
},
{
    path: '/finance/expenses/transaction/expenses-master/create',
    name: 'Create Transaction Expenses',
    meta: { title: "Create Transaction Expenses", authRequired: true },
    component: () => import('./views/Finance/Expenses/Transaction/Master/create/create-ExpensesMaster.vue'),
},

//report
//treatment
{
    path: '/report/treatment',
    name: 'List Treatment Report',
    meta: { title: "List Treatment Report", authRequired: true },
    component: () => import('./views/Report/treatment/treatmentReport.vue'),
},
//office profit
{
    path: '/report/office-profit',
    name: 'Office Profit Report',
    meta: { title: "Office Profit Report", authRequired: true },
    component: () => import('./views/Report/office_profit/officeProfitReport.vue'),
},
//revenue Report
{
    path: '/report/revenue',
    name: 'revenue Report',
    meta: { title: "Revenue Report", authRequired: true },
    component: () => import('./views/Report/revenue/revenueReport.vue'),
},
//lhk Report
{
    path: '/report/lhk',
    name: 'LHK Report',
    meta: { title: "ReveLHKnue Report", authRequired: true },
    component: () => import('./views/Report/lhk/lhkReport.vue'),
},
//salary expense
{
    path: '/report/salary-expense',
    name: 'Salary Expense Report',
    meta: { title: "Salary Expense Report", authRequired: true },
    component: () => import('./views/Report/salary_expenses/salaryExpense.vue'),
},
//Employee
//master employee
{
    path: '/master/employee/master/list',
    name: 'List Employee',
    meta: { title: "List Employee", authRequired: true },
    component: () => import('./views/Master/Employee/Master/list/listEmployee.vue'),
},
{
    path: '/master/employee/master/create',
    name: 'Create Employee',
    meta: { title: "Create Employee", authRequired: true },
    component: () => import('./views/Master/Employee/Master/create/createEmployee.vue'),
},
//role
{
    path: '/master/employee/role/list',
    name: 'List Role',
    meta: { title: "List Role", authRequired: true },
    component: () => import('./views/Master/Employee/Role/list/listRole.vue'),
},
{
    path: '/master/employee/role/create',
    name: 'Create Role',
    meta: { title: "Create Role", authRequired: true },
    component: () => import('./views/Master/Employee/Role/create/createRole.vue'),
},
//permission
{
    path: '/master/employee/permission/list',
    name: 'List Permission',
    meta: { title: "List Permission", authRequired: true },
    component: () => import('./views/Master/Employee/Permission/list/listPermission.vue'),
},
{
    path: '/master/employee/permission/create',
    name: 'Create Permission',
    meta: { title: "Create Permission", authRequired: true },
    component: () => import('./views/Master/Employee/Permission/create/createPermission.vue'),
},
//employee role
{
    path: '/master/employee/employeeRole/list',
    name: 'List Employee Role',
    meta: { title: "List Employee Role", authRequired: true },
    component: () => import('./views/Master/Employee/EmployeeRole/list/listEmployeeRole.vue'),
},
{
    path: '/master/employee/employeeRole/create',
    name: 'Create Employee Role',
    meta: { title: "Create Employee Role", authRequired: true },
    component: () => import('./views/Master/Employee/EmployeeRole/create/createEmployeeRole.vue'),
},
]


